import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const DeepSearchIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#clip0_43_23358)">
        <path
          d="M15 10.8333C15 8.53214 13.1346 6.66666 10.8334 6.66666C10.3731 6.66666 10 6.29357 10 5.83333C10 5.37309 10.3731 5 10.8334 5C14.055 5 16.6667 7.61167 16.6667 10.8333C16.6667 14.055 14.055 16.6667 10.8334 16.6667C10.3731 16.6667 10 16.2936 10 15.8333C10 15.3731 10.3731 15 10.8334 15C13.1346 15 15 13.1345 15 10.8333Z"
          fill="currentColor"
        />
        <path
          d="M14.3911 1.90553L14.463 1.95178C14.8056 2.19884 14.9118 2.67022 14.6961 3.04388L8.86276 13.1475C8.63264 13.5461 8.12298 13.6827 7.7244 13.4525L5.74751 12.3112C5.34894 12.0811 5.21237 11.5714 5.44249 11.1728L11.2758 1.06919L11.3221 0.997225C11.5692 0.65479 12.0406 0.548472 12.4142 0.764171L14.3911 1.90553Z"
          fill="currentColor"
        />
        <path
          d="M10.6769 11.7893L5.62504 8.87259L9.37504 2.3774L14.4269 5.29407L10.6769 11.7893Z"
          fill="var(--cdl-bg-faint)"
        />
        <path
          d="M14.8435 4.57238L14.9155 4.61863C15.2579 4.86573 15.3642 5.33713 15.1485 5.71073L11.3985 12.2059C11.1684 12.6045 10.6588 12.7411 10.2602 12.5109L5.20837 9.59428C4.8098 9.36416 4.67323 8.8545 4.90335 8.45592L8.65335 1.96073L8.6996 1.88877C8.9467 1.54633 9.41811 1.44001 9.79171 1.65571L14.8435 4.57238ZM6.7634 8.56757L10.3718 10.6509L13.2885 5.59909L9.68006 3.51575L6.7634 8.56757Z"
          fill="currentColor"
        />
        <path
          d="M17.0834 15.8333C17.7737 15.8333 18.3334 16.393 18.3334 17.0833C18.3334 17.7737 17.7737 18.3333 17.0834 18.3333H2.91671C2.22635 18.3333 1.66671 17.7737 1.66671 17.0833C1.66671 16.393 2.22635 15.8333 2.91671 15.8333H17.0834Z"
          fill="var(--cdl-accent-bg-base)"
        />
        <path
          d="M17.0834 17.5C17.3135 17.5 17.5 17.3134 17.5 17.0833C17.5 16.8532 17.3135 16.6667 17.0834 16.6667H2.91671C2.68659 16.6667 2.50004 16.8532 2.50004 17.0833C2.50004 17.3134 2.68659 17.5 2.91671 17.5H17.0834ZM2.91671 19.1667C1.76611 19.1667 0.833374 18.2339 0.833374 17.0833C0.833374 15.9327 1.76611 15 2.91671 15H17.0834C18.234 15 19.1667 15.9327 19.1667 17.0833C19.1667 18.2339 18.234 19.1667 17.0834 19.1667H2.91671Z"
          fill="var(--cdl-accent-bg-base)"
        />
      </g>
      <defs>
        <clipPath id="clip0_43_23358">
          <rect width="20" height="20" fill="var(--cdl-fg-faint)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DeepSearchIcon;
